import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { SUBJECT_NOTES_LIST_QUERY } from './getNotesList';
const REMOVE_NOTE_FROM_SUBJECT_MUTATION = gql `
  mutation EP_RemoveNoteFromSubject($subjectID: ID!, $noteID: ID!) {
    ep_removeNoteFromSubject(subjectID: $subjectID, noteID: $noteID)
  }
`;
export function useRemoveNoteFromSubjectMutation(options) {
    return useGQLMutation(REMOVE_NOTE_FROM_SUBJECT_MUTATION, {
        animateOnSuccess: true,
        refetchQueries: [SUBJECT_NOTES_LIST_QUERY],
        ...options,
    });
}
